var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSectorsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 22,
    height: 5.5,
    rx: 1.833
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.133 8.25H19.7c.757 0 1.063.085 1.362.245.299.16.533.394.693.693.16.299.245.605.245 1.362v.9c0 .757-.085 1.063-.245 1.362-.16.299-.394.533-.693.693-.299.16-.605.245-1.362.245h-4.567c-.757 0-1.063-.085-1.362-.245a1.666 1.666 0 0 1-.693-.693c-.16-.299-.245-.605-.245-1.362v-.9c0-.757.085-1.063.245-1.362.16-.299.394-.533.693-.693.299-.16.605-.245 1.362-.245ZM2.3 8.25h4.567c.757 0 1.063.085 1.362.245.299.16.533.394.693.693.16.299.245.605.245 1.362v.9c0 .757-.085 1.063-.245 1.362-.16.299-.394.533-.693.693-.299.16-.605.245-1.362.245H2.3c-.757 0-1.063-.085-1.362-.245a1.666 1.666 0 0 1-.693-.693C.085 12.513 0 12.207 0 11.45v-.9c0-.757.085-1.063.245-1.362.16-.299.394-.533.693-.693.299-.16.605-.245 1.362-.245Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 22a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5Zm16.5 0a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5ZM11 22a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5Z",
    opacity: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSectorsWhite);
export default __webpack_public_path__ + "static/media/ic_sectors_white.816b7ebcca79d0e8a6fc796691580991.svg";
export { ForwardRef as ReactComponent };